module.exports = __webpack_public_path__ + "img/5.534d93d7.png";